<template>
  <section>
    <cover-image
      :src="'static/bg-about.jpg'"
      :title="$t('pages.management.title')"
      :subtitle="''"
    ></cover-image>
    <div class="container content">
      <div
        class="row section"
        v-for="(section, index) in sections"
        :key="index"
      >
        <h2 class="col-12">{{ $t('pages.management.sections['+index+'].title') }}</h2>

        <div
          class="col-lg-3 person"
          v-for="(person, yndex) in section.people"
          :key="yndex"
        >
          <div class="content">
            <img
              :src="$t('pages.management.sections['+index+'].people['+yndex+'].img')"
              :alt="$t('pages.management.sections['+index+'].people['+yndex+'].name')"
            >
            <div class="signature">
              <p
                class="title"
                v-if="$t('pages.management.sections['+index+'].people['+yndex+'].title')"
              >{{ $t('pages.management.sections['+index+'].people['+yndex+'].title') }}</p>
              <h3 class="name">{{ $t('pages.management.sections['+index+'].people['+yndex+'].name') }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CoverImage from '@/components/ui/CoverImage'
import locales from '@/locales'

export default {
  name: 'ManagementView',
  metaInfo () {
    return {
      title: this.title
    }
  },
  data () {
    return {
      title: this.$t('navigation.management')
    }
  },
  components: { CoverImage },
  props: {
    language: String
  },
  computed: {
    sections: function () {
      return locales[this.language].pages.management.sections
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/_vars.scss";

.content {
  padding: 1rem 0 2rem 0;
}

.section {
  margin-bottom: 1rem;
  h2 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }
  p {
    margin-bottom: 0.5rem;
  }
}

.person {
  margin-bottom: 2rem;

  .content {
    padding: 0;
    overflow: hidden;
    background: white;
    border-radius: $border-radius-standard;
    box-shadow: $drop-shadow-card;
    transition: all 0.2s;

    &:hover {
      transform: scale(1.05, 1.05);
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    }

    .signature {
      padding: 1rem;
      background: $white;
      text-align: left;
    }
  }

  img {
    width: 100%;
    display: block;
  }

  .name {
    margin: 0;
    font-size: 1rem;
  }

  .title {
    margin: 0;
    text-transform: uppercase;
    font-size: 0.75rem;
    font-weight: $semibold;
    color: $primary-color;
  }
}
</style>



// WEBPACK FOOTER //
// ManagementView.vue?2549e694